import { ContactAdminComponent } from './shared/components/authentication/contact-admin/contact-admin.component';
import { NgModule, Component } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Roles } from './shared/models/roles.enum';
import { AuthGuard } from './shared/services/authentication/auth.guard';
import { NotAuthorizedComponent } from './shared/components/authentication/not-authorized/not-authorized.component';
import { ServerErrorComponent } from './shared/components/authentication/server-error/server-error.component';
import { NotFoundComponent } from './shared/components/authentication/not-found/not-found.component';
import { PortalHomeComponent } from './base-components/home/portal-home/portal-home.component';
import { SystemRoles } from './shared/services/authentication/roleEnum';
import { IamCallbackComponent } from './shared/components/authentication/iam-callback/iam-callback.component';
import { UserInfoComponent } from './shared/components/user-info/user-info.component';
import { LoginComponent } from './shared/components/authentication/login/login.component';
import { LoginusingforignerComponent } from './shared/components/authentication/loginusingforigner/loginusingforigner.component';
import { RegisterusingforignerComponent } from './shared/components/authentication/registerusingforigner/registerusingforigner.component';
import { ChangepasswordComponent } from './shared/components/authentication/changepassword/changepassword.component';
import { VerifyusingotpComponent } from './shared/components/authentication/verifyusingotp/verifyusingotp.component';
import { NotActiveComponent } from './shared/components/authentication/not-active/not-active.component';
import { ForgetepasswordComponent } from './shared/components/authentication/forgetepassword/forgetepassword.component';
import { MainlayoutComponent } from './shared/components/mainlayout/mainlayout.component';
import { CompleteCompanyComponent } from './shared/components/complete-company/complete-company.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./shared/components/authentication/login.module').then(m => m.LoginModule)
  },
  
  {
    path: 'iam_callback',
    component: IamCallbackComponent,
  },
  
  {
    path: '',
    component:MainlayoutComponent,
    children:[
    {
      path:'',
      component:PortalHomeComponent
    },
    {
      path: 'changepassword',
      component: ChangepasswordComponent,
    },
    {
      path: 'not-active',
      component: NotActiveComponent
    },
   
    {
      path: 'get-user-info',
      component: UserInfoComponent,
    }, 
    {
      path: 'complete-company/:id',
      component: CompleteCompanyComponent
    },
    {
      path: 'admin',
      canActivate: [AuthGuard],
      loadChildren: () =>
        import('./modules/admin/admin.module').then((m) => m.AdminModule),
      data: {
        roles: [SystemRoles[SystemRoles.Admin],
                SystemRoles[SystemRoles.AdministrationAndFacilitiesDepartment]],
      },
    },
    {
      path: 'requests',
      canActivate: [AuthGuard],
      loadChildren: () =>
        import('./modules/workFlow/workflow.module').then(
          (m) => m.WorkflowModule
        ),
    },
    {
      path: 'services',
      // canActivate: [AuthGuard],
      loadChildren: () =>
        import('./modules/services/services.module').then(
          (m) => m.ServicesModule
        ),
    },
    
    {
      path: '401',
      component: NotAuthorizedComponent,
      //canActivate: [AuthGuard],
    },
    {
      path: 'contactadmin',
      component: ContactAdminComponent
    },
    {
      path: '500',
      component: ServerErrorComponent,
      //canActivate: [AuthGuard],
    },
    {
      path: '**',
      component: NotFoundComponent,
      //canActivate: [AuthGuard],
    },
    ],
    
     canActivate: [AuthGuard],
  },
  
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', preloadingStrategy: PreloadAllModules }),//scrollPositionRestoration to auto scroll to top of screen
  ],
  exports: [RouterModule],
  providers: [TranslateService],
})
export class AppRoutingModule {}
